import React from 'react';
import {View, Text} from '@react-pdf/renderer';
import styles, {getDepotAddress} from '../../Foundations/Utils/PDFUtils';
import {IResultsData, IResultSummary} from '../../Foundations/Types/IResultsData';
import {getSupplierName} from '../../Foundations/Utils/SupplierUtils';
import {IDepotInfo, IDepotSummary} from '../../Foundations/Types/IDepot';

interface IProps {
    results: IResultsData[];
    depotsAtArea: IDepotInfo[];
    resultSummary: IResultSummary;
}

const ReportResults: React.FC<IProps> = (props) => {
    let cheapestDepotIndex = {
        index: -1,
        id: -1
    };
    let closestDepotIndex = {
        index: -1,
        id: -1
    };

    props.resultSummary.depotSummary.forEach((summary: IDepotSummary, index) => {
        if (
            props.resultSummary.lowestPerDay !== null &&
            summary.lowestPerDay !== null &&
            summary.lowestPerDay.id === props.resultSummary.lowestPerDay.id
        ) {
            cheapestDepotIndex.index = index + 1;
            cheapestDepotIndex.id = summary.lowestPerDay.id;
        }

        if (
            summary.lowestPerDay !== null &&
            cheapestDepotIndex.id !== summary.lowestPerDay.id &&
            index === 0
        ) {
            closestDepotIndex.id = summary.lowestPerDay.id;
            closestDepotIndex.index = index + 1;
        }
    });

    return (
        <View>
            <View style={[{marginTop: 24}, { marginBottom: 12 }]}>
                <Text style={{...styles.fontXl, ...styles.fontBold}}>
                    Vehicle rate results
                </Text>
                <Text style={[{fontSize: 10}]}>
                    Showing {props.results.length} results
                </Text>
            </View>
            <View style={{...styles.wFull, ...styles.row, ...styles.tableHeader}} >
                <View style={styles.numberCol} />
                <View style={{...styles.perDayCol}}>
                    <Text style={{...styles.fontBold}}>Per Day</Text>
                </View>
                <View style={{...styles.durationCol}}>
                    <Text style={{...styles.wFull, ...styles.fontBold}}>Duration</Text>
                    <Text>Total$</Text>
                </View>
                <View style={{...styles.modelCol}}>
                    <Text style={{...styles.wFull, ...styles.fontBold}}>Model</Text>
                    <Text>class</Text>
                </View>
                <View style={{...styles.seatsCol}}>
                    <Text style={{...styles.wFull, ...styles.fontBold}}>Seats</Text>
                </View>
                <View style={{...styles.supplierCol}}>
                    <Text style={{...styles.fontBold}}>Supplier</Text>
                </View>
                <View style={{...styles.depotCol}}>
                    <Text style={{...styles.fontBold}}>Depot location</Text>
                </View>
            </View>
            {
                props.results.map((result, index) => (
                    <View
                        wrap={false}
                        key={result.id}
                        style={[{...styles.wFull, ...styles.row}, {backgroundColor: index % 2 === 0 ? '#ffffff' : '#F5F6FA'}, {fontSize: 7}]}
                    >
                        <View style={{...styles.numberCol, ...{display: 'flex', alignItems: 'flex-end'}}}>
                            {
                                result.id === cheapestDepotIndex.id &&
                                <View style={[
                                    {...styles.depotSummaryIndexNumber},
                                    { backgroundColor: '#0A68FF'},
                                    { marginLeft: 5}
                                ]}>

                                    <Text>{cheapestDepotIndex.index}</Text>
                                </View>
                            }
                            {
                                result.id === closestDepotIndex.id &&
                                <View style={[
                                    {...styles.depotSummaryIndexNumber},
                                    { backgroundColor: '#EA913A'},
                                    { marginLeft: 5}
                                ]}>
                                    <Text>{closestDepotIndex.index}</Text>
                                </View>
                            }
                        </View>
                        <View style={{...styles.perDayCol}}>
                            <Text style={{...styles.fontBold}}>${result.per_day_price}</Text>
                        </View>
                        <View style={{...styles.durationCol}}>
                            <Text style={{...styles.wFull, ...styles.fontBold}}>
                                {result.duration} day{result.duration > 1 ? 's' : ''}
                            </Text>
                            <Text>${result.total_rate_estimate}</Text>
                        </View>
                        <View style={{...styles.modelCol}}>
                            <Text style={{...styles.wFull, ...styles.fontBold}}>
                                {result.vehicle_data.name}
                            </Text>
                            <Text>{result.vehicle_data.category} - {result.vehicle_data.type} - {result.sipp_code}</Text>
                        </View>
                        <View style={{...styles.seatsCol}}>
                            <Text style={{...styles.wFull, ...styles.fontBold}}>
                                {result.vehicle_data.seats}
                            </Text>
                        </View>
                        <View style={{...styles.supplierCol}}>
                            <Text style={{...styles.fontBold}}>
                                {result.supplier_name || getSupplierName(result.supplier_code)}
                            </Text>
                        </View>
                        <View style={{...styles.depotCol}}>
                            <Text  style={{...styles.fontBold}}>
                                {result.depot_code}
                            </Text>
                            <Text>
                                {getDepotAddress(props.depotsAtArea, `${result.depot_code}_${result.supplier_code}`)}
                            </Text>
                        </View>
                    </View>
                ))
            }
        </View>
    )
}

export default ReportResults;
